import en from "./languages/en.json";
import ar from "./languages/ar.json";
export default {
  ar: ar,
  en: en
}; //

export { default as authMessages } from "./messages/auth/messages";
export { default as messagesMessages } from "./messages/messages";
export { default as announceMessages } from "./messages/announcements";
export { default as sidebarMessages } from "./messages/general/sidebar";
export { default as userMenuPopOverMessages } from "./messages/general/userMenuPopOver";
export { default as linkedAccountsMessages } from "./messages/general/linkedAccounts";
export { default as profileSettingsMessages } from "./messages/general/profileSettings";
export { default as questionBankMessages } from "./messages/questionbank";
export { default as coursesMessages } from "./messages/courses";
export { default as gradebookMessages } from "./messages/gradebook";
export { default as dashboardMessages } from "./messages/dashboard";
export { default as moreMessages } from "./messages/more";
export { default as notificationMessages } from "./messages/notifications/messages";
export { default as materialMessages } from "./messages/materials/messages";
export { default as commonMessages } from "./messages/common/messages";
export { default as channelbookMessages } from "./messages/channelbook/messages";
export { default as schoolAdminMessages } from "./messages/schoolAdmin/messages";
export { default as parentMessages } from "./messages/parent/messages";
export { default as calendarMessages } from "./messages/calendar/messages";
export { default as scheduleMessages } from "./messages/schedule/messages";
export { default as performanceMessages } from "./messages/performance/messages";
export { default as trashBinMessages } from "./messages/trashBin/messages";
export { default as certificatesMessages } from "./messages/certificates";
export { default as paymentMessages } from "./messages/payment/messages";
export { default as attendanceMessages } from "./messages/attendance/messages";
export { default as complaintsMessages } from "./messages/complaints/messages";
export { default as dismissalMessages } from "./messages/dismissal/messages";